const request_methods = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE',
};

const auth_routes = {
  login: 'affiliate/login',
};

const register_routes = {
  register: 'affiliate/signup',
  check_user_exist: 'affiliate/check_user_exists',
};

const change_password_routes = {
  forgot_password: 'affiliate/forgot_password',
  reset_password: 'affiliate/reset_password',
  change_password: 'affiliate/change_password',
};

const shared_routes = {
  get_countries: 'backoffice/countries',
  get_account_manager_info: 'affiliate/account/manager/info',
  get_news: 'affiliate/news',
  get_sites: 'backoffice/affiliate/sites',
};

const user_profile_routes = {
  get_user_profile: 'affiliate/user_profile',
  edit_user_profile: 'affiliate/edit_user_profile',
};

const payment_routes = {
  get_user_balance: 'affiliate/user_balance',
  request_withdrawal: 'affiliate/withdrawal',
  get_payment_history: 'affiliate/withdrawals',
  get_user_payment_methods: 'affiliate/payment/methods',
  get_payment_method_types: 'affiliate/payment/methods/types',
  save_user_payment_method: 'affiliate/payment/methods',
  get_rate: 'affiliate/payment/rate',
};

const dashboard_routes = {
  get_chart_data: 'affiliate/clicks/chart',
  get_summary: 'affiliate/summary',
};

const campaigns_routes = {
  get_campaigns: 'affiliate/partner_codes',
  add_campaign: 'affiliate/custom_code',
  edit_campaign: 'affiliate/edit_custom_code',
  request_install_link: 'affiliate/request_install_link',
};

const clients_routes = {
  get_clients: 'affiliate/referral_details',
};

const commission_routes = {
  get_commissions: 'affiliate/commission/plans',
  get_promotions: 'affiliate/promotions',
};

const sources_routes = {
  get_sources: 'affiliate/srouces',
};

const reports_routes = {
  get_reports: 'affiliate/reports',
};

const b2b_routes = {
  get_keys: 'b2b/api_keys',
  generate_key: 'b2b/generate_api_key',
  deactivate_key: 'b2b/deactivate_api_key',
};

export default {
  request_methods,
  auth_routes,
  register_routes,
  change_password_routes,
  shared_routes,
  user_profile_routes,
  payment_routes,
  dashboard_routes,
  campaigns_routes,
  clients_routes,
  commission_routes,
  sources_routes,
  reports_routes,
  b2b_routes,
};



// WEBPACK FOOTER //
// ./src/api/constants/api-constants.js